import React from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Progress } from '../ui/progress';
import { Sparkles, Loader2 } from 'lucide-react';

export const ClassicCreator = ({
  prompt, setPrompt,
  genre, setGenre,
  style, setStyle,
  difficulty, setDifficulty,
  generating, progress, status,
  onGenerate,
}) => (
  <div className="max-w-3xl mx-auto">
    <p className="text-gray-400 mb-4 text-sm">
      Classic mode uses the original one-shot generation pipeline. It is less powerful than the conversational agent
      but kept here as a backup.
    </p>
    <form onSubmit={onGenerate} className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border border-white/10 space-y-6">
      <div>
        <Label htmlFor="prompt-classic" className="text-white text-lg mb-3 block">
          Game Description
        </Label>
        <Textarea
          id="prompt-classic"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="Describe your game..."
          className="bg-black/50 border-white/10 text-white min-h-32 text-base"
          required
        />
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div>
          <Label htmlFor="genre" className="text-white mb-2 block">Genre</Label>
          <Select value={genre} onValueChange={setGenre}>
            <SelectTrigger className="bg-black/50 border-white/10 text-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="arcade">Arcade</SelectItem>
              <SelectItem value="platformer">Platformer</SelectItem>
              <SelectItem value="puzzle">Puzzle</SelectItem>
              <SelectItem value="action">Action</SelectItem>
              <SelectItem value="adventure">Adventure</SelectItem>
              <SelectItem value="shooter">Shooter</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label htmlFor="style" className="text-white mb-2 block">Art Style</Label>
          <Select value={style} onValueChange={setStyle}>
            <SelectTrigger className="bg-black/50 border-white/10 text-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="pixel art">Pixel Art</SelectItem>
              <SelectItem value="cartoon">Cartoon</SelectItem>
              <SelectItem value="minimalist">Minimalist</SelectItem>
              <SelectItem value="retro">Retro</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label htmlFor="difficulty" className="text-white mb-2 block">Difficulty</Label>
          <Select value={difficulty} onValueChange={setDifficulty}>
            <SelectTrigger className="bg-black/50 border-white/10 text-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="easy">Easy</SelectItem>
              <SelectItem value="medium">Medium</SelectItem>
              <SelectItem value="hard">Hard</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <Button
        type="submit"
        size="lg"
        className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white text-lg py-6"
      >
        <Sparkles className="mr-2" size={20} />
        Generate Game with AI (Classic)
      </Button>

      {generating && (
        <div className="mt-6 text-center space-y-4">
          <Loader2 className="w-10 h-10 text-purple-500 animate-spin mx-auto" />
          <p className="text-gray-300">{status}</p>
          <div className="max-w-md mx-auto">
            <Progress value={progress} className="h-2" />
            <p className="text-white mt-2 text-sm font-semibold">{progress}%</p>
          </div>
        </div>
      )}
    </form>
  </div>
);
